;(function () {
const CLOSE_DELAY = 2000

const SELECTORS = {
  trigger: '[data-coming-soon-trigger]',
  close: '.coming-soon-modal__close',
  submit: '.coming-soon-modal__submit',
  input: '.coming-soon-modal__input',
  error: '.coming-soon-modal__error',
  success: '.coming-soon-modal__success',
  formWrapper: '.coming-soon-modal__form-wrapper',
  productName: '.coming-soon-modal__product-name',
}

const SETTINGS = window.comingSoonSettings || {}

const MODAL_HTML = `
  <div class="coming-soon-modal__container">
    <button class="coming-soon-modal__close" type="button" aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
    <h2 class="coming-soon-modal__title">${SETTINGS.modalTitle || 'Avisarme cuando este disponible'}</h2>
    <p class="coming-soon-modal__text">${SETTINGS.modalText || 'Deja tu email y te avisamos cuando el producto este disponible.'}</p>
    <p class="coming-soon-modal__product-name"></p>
    <div class="coming-soon-modal__form-wrapper">
      <input class="coming-soon-modal__input" type="email" placeholder="${SETTINGS.inputPlaceholder || 'Tu email'}" required autocomplete="email">
      <div class="coming-soon-modal__error">${SETTINGS.errorText || 'Ocurrio un error. Intenta nuevamente.'}</div>
      <button class="coming-soon-modal__submit" type="button">${SETTINGS.submitText || 'AVISARME'}</button>
    </div>
    <p class="coming-soon-modal__success">${SETTINGS.successText || 'Te avisaremos cuando el producto este disponible.'}</p>
  </div>
`

/* ----------------------------------------
   Modal
   ---------------------------------------- */

let modalEl = null
let currentProductId = null

const getModal = () => {
  if (modalEl) return modalEl

  modalEl = document.createElement('div')
  modalEl.className = 'coming-soon-modal'
  modalEl.innerHTML = MODAL_HTML
  document.body.appendChild(modalEl)

  bindModalEvents(modalEl)
  return modalEl
}

const openModal = (productId, productTitle) => {
  const modal = getModal()
  currentProductId = productId

  modal.querySelector(SELECTORS.productName).textContent = productTitle

  /* Reset state */
  modal.querySelector(SELECTORS.formWrapper).style.display = ''
  modal.querySelector(SELECTORS.success).classList.remove('visible')
  modal.querySelector(SELECTORS.error).classList.remove('visible')
  modal.querySelector(SELECTORS.input).value = ''
  modal.querySelector(SELECTORS.input).classList.remove('error')
  modal.querySelector(SELECTORS.submit).disabled = false

  /* Force reflow so the transition plays on first open */
  void modal.offsetHeight
  modal.classList.add('active')
  document.body.classList.add('overflow-hidden')
  modal.querySelector(SELECTORS.input)?.focus()
  document.addEventListener('keydown', handleEsc)
}

const closeModal = () => {
  if (!modalEl) return
  modalEl.classList.remove('active')
  document.body.classList.remove('overflow-hidden')
  document.removeEventListener('keydown', handleEsc)
}

const handleEsc = ({ key }) => {
  if (key === 'Escape') closeModal()
}

/* ----------------------------------------
   Form submit (AJAX)
   ---------------------------------------- */

const handleSubmit = async (modal) => {
  const emailInput = modal.querySelector(SELECTORS.input)
  const submitBtn = modal.querySelector(SELECTORS.submit)
  const errorEl = modal.querySelector(SELECTORS.error)
  const successEl = modal.querySelector(SELECTORS.success)
  const formWrapper = modal.querySelector(SELECTORS.formWrapper)

  emailInput.classList.remove('error')
  errorEl.classList.remove('visible')

  if (!emailInput.value || !emailInput.validity.valid) {
    emailInput.classList.add('error')
    return
  }

  submitBtn.disabled = true

  const body = new FormData()
  body.append('form_type', 'customer')
  body.append('utf8', '\u2713')
  body.append('contact[tags]', `coming_soon, coming_soon_${currentProductId}`)
  body.append('contact[email]', emailInput.value)
  body.append('contact[accepts_marketing]', 'true')

  try {
    const response = await fetch('/contact', {
      method: 'POST',
      body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })

    if (!response.ok) throw new Error(response.status)

    formWrapper.style.display = 'none'
    successEl.classList.add('visible')

    setTimeout(closeModal, CLOSE_DELAY)
  } catch {
    errorEl.classList.add('visible')
    emailInput.classList.add('error')
    submitBtn.disabled = false
  }
}

/* ----------------------------------------
   Event binding
   ---------------------------------------- */

const bindModalEvents = (modal) => {
  modal.querySelector(SELECTORS.close).addEventListener('click', closeModal)

  modal.addEventListener('click', ({ target }) => {
    if (target === modal) closeModal()
  })

  modal.querySelector(SELECTORS.submit).addEventListener('click', () => {
    handleSubmit(modal)
  })

  modal.querySelector(SELECTORS.input).addEventListener('keydown', ({ key }) => {
    if (key === 'Enter') handleSubmit(modal)
  })
}

/* ----------------------------------------
   Init — Event delegation for all triggers
   ---------------------------------------- */

document.addEventListener('click', (e) => {
  const trigger = e.target.closest(SELECTORS.trigger)
  if (!trigger) return

  e.preventDefault()
  e.stopPropagation()
  openModal(trigger.dataset.productId, trigger.dataset.productTitle)
})
})()
